import service from '@/utils/request.js'
export default{
    //登录
    login_xp(data){
        data.action='login_xp'
        return service.post('',data)
    },
    //获取任务信息
    get_task_info(data){
        data.action='get_task_info'
        return service.post('',data)
    },
    //保存标记
    save_marks(data){
        data.action='save_marks'
        return service.post('',data)
    },
    //获取用户信息
    get_user_info(data){
        data.action='get_user_info'
        return service.post('',data)
    },
    //修改选片状态
    set_xp_status(data){
        data.action='set_xp_status'
        return service.post('',data)
    },
    captcha(data){
        data.action='captcha'
        return service.post('',data)
    },
    get_update_log(data){
        data.action='get_update_log'
        return service.post('',data)
    },
    get_update_log_mac(data){
        data.action='get_update_log_mac'
        return service.post('',data)
    },
    get_task_marks(data){
        data.action='get_task_marks'
        return service.post('',data)
    },
    get_douyin_help_src(data){
        data.action='get_douyin_help_src'
        return service.post('',data)
    },
    get_uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}